module.exports = __webpack_public_path__ + "static/img/fayuan-icon5.50c7a222.png";